import React from 'react';
import { Reveal } from './Reveal';
export function ProductSection() {
  return <section className="w-full bg-ivory py-20 md:py-28" aria-labelledby="producto" data-id="element-194" data-mp="2udv6qu3d4q2">
      <div className="mx-auto grid max-w-6xl items-center gap-14 px-6 md:grid-cols-2 lg:px-8" data-id="element-195" data-mp="2sj5kz7vkofn">
        <Reveal data-id="element-196" data-mp="hlcutccy8ixi">
          <div className="relative" data-id="element-197" data-mp="csjqgple7cly">
            <div aria-hidden="true" className="absolute -left-4 -top-4 h-24 w-24 rounded-full border border-goldsoft/60" data-id="element-198" data-mp="crifsm8ags4r" />
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/36cc61f7-6141-4a79-9703-8eb483583f2d.jpg" alt="Guía de 7 días La mujer que olvidaste ser en formato digital e impreso" className="relative w-full rounded-[2rem] object-cover shadow-[0_40px_90px_-55px_rgba(58,51,46,0.5)]" loading="lazy" data-id="element-199" data-mp="qi54rmo8z3nn" />
          </div>
        </Reveal>

        <div data-id="element-200" data-mp="328zbuj69d7ax">
          <Reveal data-id="element-201" data-mp="328pmmxt1f46a">
            <p className="font-sans text-[0.6rem] uppercase tracking-luxe text-gold" data-id="element-202" data-mp="32aagel7j2j33">
              Guía principal
            </p>
            <h2 id="producto" className="mt-4 font-display text-[2.1rem] font-light leading-[1.15] text-ink sm:text-4xl" data-id="element-203" data-mp="2xcilrjfi0iv7">
              Tu guía de 7 días para volver a ti.
            </h2>
            <span aria-hidden="true" className="mt-7 block h-[1px] w-16 bg-goldsoft" data-id="element-204" data-mp="1bfotc5ro9hz" />
          </Reveal>

          <Reveal delay={0.08} data-id="element-205" data-mp="5aof271llp8s">
            <p className="mt-8 font-sans text-[1rem] font-light leading-[1.9] text-warmgray" data-id="element-206" data-mp="a4124cqmpnzf">
              Dentro encontrarás ejercicios diarios, reflexiones profundas y acciones simples para
              empezar a reconstruir tu relación contigo.
            </p>
          </Reveal>
          <Reveal delay={0.14} data-id="element-207" data-mp="p0s32qfyb7r5">
            <p className="mt-5 font-display text-xl font-light italic leading-relaxed text-ink" data-id="element-208" data-mp="p0i96rrscgg6">
              No necesitas horas. Solo unos minutos al día y la decisión de volver a escucharte.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}